export enum AuditType {
  ADVANCED_PAYMENTS = 'Advanced Payments',
  EMPLOYEE = 'Employee',
  LOAN_AGREEMENT = 'Loan Agreement',
  LOAN_PAYMENT = 'Loan Payment',
}

export enum AuditAction {
  CREATED = 'Created',
  UPDATED = 'Updated',
  DELETED = 'Deleted',
}

export type IAuditTableFilterValue = string | string[];

export type IAuditTableFilters = {
  generalSearch: string;
  type: AuditType | '';
  action: AuditAction | '';
  actorId: string;
  startDate: Date | null;
  endDate: Date | null;
};

export type IAuditTableSort = {
  sortBy: string;
  order: 'asc' | 'desc';
};

export interface IAuditMetadata {
  ipAddress?: string;
  userAgent?: string;
}

export interface IAuditListItem {
  _id: string;
  type: AuditType;
  action: AuditAction;
  entityId: string;
  actorId: string;
  actorEmail: string;
  before: Record<string, any> | null;
  after: Record<string, any> | null;
  metadata: IAuditMetadata;
  createdAt: string;
}
